module.exports = __webpack_public_path__ + "fonts/source-code-pro-v22-latin-regular.157524b5.woff2";